import { render } from "./Links.vue?vue&type=template&id=6f9f8bd5&scoped=true"
const script = {}

import "./Links.vue?vue&type=style&index=0&id=6f9f8bd5&scoped=true&lang=css"

import exportComponent from "F:\\.openserver\\OpenServer\\domains\\geo_exams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f9f8bd5"]])

export default __exports__